import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/states.svg',
})
export class StatesComponent {}
